import React, { Component } from 'react'
import EventsPageCard from '../events/eventsPageCard';
import axios from 'axios';
import '../events/eventsCard.css'

export default class EventsPage extends Component {
    render() {
        return (

            <React.Fragment>
            <div className="events-page-container">
                <p> 
                Fundraising events are held not only to honor Alan’s memory but also to support the causes he cared deeply about. 
                Proceeds from these events, including the annual Alan J. Anderson Foundation Golf Outing, help fund scholarships for students at New Milford High School and William Paterson University, as well as grants to organizations leading the fight against cancer through research and treatment.
                </p>
                <br/>
                <p>
                These efforts ensure that Alan’s legacy lives on—empowering students and advancing the search for a cure.
                </p>
            </div>

            <div className="upcoming-events-section2">
            <div className="up-events2">
                <h1>Upcoming Events</h1>
             </div>
             </div>

            <EventsPageCard/>

            </React.Fragment>

        )
    }
}
